// extracted by mini-css-extract-plugin
export default {"wrapper":"CommonItem_wrapper__WvVS+","thumb":"CommonItem_thumb__4DHs1","ctaBtn":"CommonItem_ctaBtn__FeYID","title":"CommonItem_title__4CUcz"};